import React, { memo, useCallback, useState } from 'react';

import { Box, Typography } from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconDirection } from 'constants/coreDesignSystem';

import { ImportMismoIntoLoanModalTestIds } from '../../ImportMismoIntoLoanModal.testIds';
import { getChangeRowKey, getSectionMetaText } from '../../ImportMismoIntoLoanModal.utils';
import MismoChangeCard from '../MismoChangeCard';

import {
  cardsContainerStyles,
  getExpandIconStyles,
  sectionGroupStyles,
  sectionHeaderLeftStyles,
  sectionHeaderStyles,
  sectionMetaStyles,
  sectionTitleStyles,
} from './MismoChangeSectionGroup.styles';

const MismoChangeSectionGroup = ({ section, changes }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpand = useCallback(() => setIsExpanded(prev => !prev), []);

  return (
    <Box sx={sectionGroupStyles}>
      <Box
        data-testid={ImportMismoIntoLoanModalTestIds.SECTION_GROUP}
        sx={sectionHeaderStyles}
        onClick={toggleExpand}
      >
        <Box sx={sectionHeaderLeftStyles}>
          <Typography sx={sectionTitleStyles} variant="bold14">
            {section}
          </Typography>
          <Typography sx={sectionMetaStyles} variant="regular12">
            — {getSectionMetaText(changes.length)}
          </Typography>
        </Box>
        <ArrowCheckIcon direction={IconDirection.DOWN} style={getExpandIconStyles(isExpanded)} />
      </Box>

      {isExpanded && (
        <Box sx={cardsContainerStyles}>
          {changes.map(change => (
            <MismoChangeCard change={change} key={getChangeRowKey(change)} />
          ))}
        </Box>
      )}
    </Box>
  );
};

MismoChangeSectionGroup.propTypes = {
  section: PropTypes.string.isRequired,
  changes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default memo(MismoChangeSectionGroup);
